import React, {ChangeEvent} from "react"
import {Typography, RadioGroup, Radio} from "@mui/material"
import FormControlLabel from "@mui/material/FormControlLabel"
import {AlternativeBillingAddressSection} from "./AlternativeBillingAddressSection"
import {useDispatch, useSelector} from "react-redux"
import {setBilling, unsetBilling} from "../../../features/project/billingSlice"
import Grid from "@mui/material/Grid2"
import {RootState} from "../../../reducers"

const TitleItem: React.FC = () => (
    <>
        <Grid size={12}>
            <Typography component="h1" variant="h4">
                Rechnungsadresse
            </Typography>
            <hr/>
        </Grid>
    </>
)

export const BillingAddressSection: React.FC = () => {
    const dispatch = useDispatch()
    const billing = useSelector((state: RootState) => state.project.billing)
    const customer = useSelector((state: RootState) => state.user)
    const hasCustomBilling = useSelector((state: RootState) => !!state.project.billing)

    const handleCustomBillingChange = (event: ChangeEvent<HTMLInputElement>) => {
        const customBilling = event.target.value === "true"
        dispatch(customBilling ? setBilling(null) : unsetBilling(null))
    }

    return (
        <Grid container size={12} spacing={6}>
            <TitleItem/>
            <Grid mb={2}>
                <RadioGroup value={hasCustomBilling} onChange={handleCustomBillingChange}>
                    <Grid>
                        <FormControlLabel value={false} control={<Radio/>} label="Gleich wie Kundenadresse"/>
                        <Typography ml={4}>
                            <b>{customer.company},</b> {customer.lastname} {customer.firstname}, {customer.address}, {customer.zip} {customer.city}
                        </Typography>
                    </Grid>
                    <Grid mt={3}>
                        <FormControlLabel value={true} control={<Radio/>}
                                          label="Alternative Rechnungsadresse erfassen"/>
                    </Grid>
                </RadioGroup>
            </Grid>
            {!!billing && <AlternativeBillingAddressSection/>}
        </Grid>
    )
}